export interface User {
  uid: string;
  token: string;
}

export const ID_TOKEN_KEY = "api";
